"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Hitagi_Plugin_Utils {
    constructor() {
        this.callback__redirect = function (Args) {
            window.location.assign(Args.href);
        };
    }
}
exports.default = Hitagi_Plugin_Utils;
